export enum ViewType {
  DETAIL = "detail",
  LINKS_ONLY = "links_only",
}

export enum LocationTiers {
  CITY = "multi_city_vicinity,city",
  NEIGHBORHOOD = "neighborhood",
}
